import request from '@/utils/request'

/**
 * 获取纪念人列表
 * @param {Object} params
 * @param {number} params.page - 当前页码
 * @param {number} params.page_size - 每页条数
 * @param {string} params.search - 搜索关键词
 */
export function getPersonList(params) {
  return request.get('/asset/person/all', params)
}

/**
 * 删除纪念人
 * @param {number} personId - 纪念人ID
 */
export function deletePerson(personId) {
  return request.post('/asset/person/delete_person', { person_id: personId })
}